import { Component, OnInit, ViewChild, TemplateRef, Output, Input, OnChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Subject ,  Observable } from 'rxjs';

import { DistributionObjectService } from './services/distribution-object.service';
import { DocumentTypeEntity } from './models/distribution-object';
import { DistributionObjectGroup } from './models/distribution-object-group';

import { DxLookupComponent } from "devextreme-angular";

import { FormsModule } from '@angular/forms';

@Component({
    templateUrl: './distribution-object-selector.component.html',
    selector: 'ep-distribution-object-selector',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})

export class DistributionObjectSelectorComponent implements OnInit, OnChanges {

    constructor(private distributionObjectService: DistributionObjectService) { }

    initializedSubject: Subject<void> = new Subject<void>();
    public initialized: Observable<void> = this.initializedSubject.asObservable();

    @Input() selectedDistributionObject: DocumentTypeEntity = null;
    @Output() selectedDistributionObjectChange: EventEmitter<DocumentTypeEntity> = new EventEmitter<DocumentTypeEntity>();
    @Output() selectedDistributionObjectGroupChange: EventEmitter<DistributionObjectGroup> = new EventEmitter<DistributionObjectGroup>();

    @Input() showSearchForUnknown: boolean = false;
    @Input() includeOnlyUsableForDistributions: boolean = true;

    public distributionObjectGroups: DistributionObjectGroup[];
    public selectedDistributionObjectGroup: DistributionObjectGroup;
    public allGroup = new DistributionObjectGroup();
    public unknownDistributionObject: DocumentTypeEntity;

    ngOnInit(): void {
        this.distributionObjectService.getDistributionObjectGroups(this.includeOnlyUsableForDistributions).then((groups) => {
            this.distributionObjectGroups = groups;

            this.allGroup.Name = 'All';
            this.allGroup.DistributionObjects = [];

            for (let group of this.distributionObjectGroups) {
                this.allGroup.DistributionObjects = this.allGroup.DistributionObjects.concat(group.DistributionObjects);
            }

            if (this.showSearchForUnknown) {
                this.unknownDistributionObject = {} as DocumentTypeEntity;
                this.unknownDistributionObject.Id = -1;
                this.unknownDistributionObject.Name = `Search for 'Unknown' document types`;
            }

            // Sort the groups and distribution-objects
            this.distributionObjectGroups.sort((dog1, dog2) => dog1.Name.localeCompare(dog2.Name));
            this.distributionObjectGroups.forEach((dog) => dog.DistributionObjects.sort((do1, do2) => do1.Name.localeCompare(do2.Name)));
            this.allGroup.DistributionObjects.sort((do1, do2) => do1.Name.localeCompare(do2.Name));

            this.selectedDistributionObjectGroup = this.allGroup;

            this.initializedSubject.next();
            this.initializedSubject.complete();
        });
    }

    public reset() {
        this.selectedDistributionObjectGroup = this.allGroup;
        this.setSelectedDistributionObjectId(null);
    }

    public setSelectedDistributionObjectId(distributionObjectId: number) {
        let isFound = false;

        if (distributionObjectId == -1) {
            this.selectedDistributionObjectGroup = this.allGroup;
            this.distributionObjectChanged(this.unknownDistributionObject);
            isFound = true;
        }
        else {
            if (this.distributionObjectGroups) {
                for (let group of this.distributionObjectGroups) {
                    let distributionObject = group.DistributionObjects.find((d) => d.Id == distributionObjectId);
                    if (distributionObject) {
                        this.selectedDistributionObjectGroup = group;
                        this.distributionObjectChanged(distributionObject);
                        isFound = true;
                        break;
                    }
                }
            }
        }

        if (!isFound) {
            this.distributionObjectChanged(null);
        }
    }

    public setSelectedDistributionObjectGroupId(distributionObjectGroupId: number) {
        if (distributionObjectGroupId) {
            let distributionObjectGroup = this.distributionObjectGroups.find(g => g.DistributionObjectGroupId == distributionObjectGroupId);
            if (distributionObjectGroup) {
                this.selectedDistributionObjectGroup = distributionObjectGroup;
                return;
            }
        }

        this.selectedDistributionObjectGroup = this.allGroup;
    }

    distributionObjectGroupChanged(distributionObjectGroup: DistributionObjectGroup) {
        this.selectedDistributionObjectGroup = distributionObjectGroup;
        this.selectedDistributionObjectGroupChange.emit(distributionObjectGroup);

        if (this.selectedDistributionObject) { // Check if the currently selected distribution-object also exist in the newly selected group. If so - keep the selected-distribution-object
            let distributionObjectInSelectedGroup = distributionObjectGroup.DistributionObjects.find(d => d.Id == this.selectedDistributionObject.Id) || null; // Need to be null and not 'undefined' because the dropdown 
            this.distributionObjectChanged(distributionObjectInSelectedGroup);
        }
        else { // Otherwise reset the selected distribution-object to "All"
            this.distributionObjectChanged(null);
        }
    }

    distributionObjectChanged(distributionObject: DocumentTypeEntity) {
        this.selectedDistributionObject = distributionObject;
        this.selectedDistributionObjectChange.emit(distributionObject);
    }

    ngOnChanges(changes: any) {
        if (changes.selectedDistributionObject) {
            this.selectedDistributionObjectChange.emit(this.selectedDistributionObject);
        }
    }
}
